const selectData = (state) => state.resolutioncenter.reportedIncidents.data
const selectLoader = (state) => state.resolutioncenter.reportedIncidents.loader
const selectError = (state) => state.resolutioncenter.reportedIncidents.error

const selectSearch = (state) => state.resolutioncenter.reportedIncidents.search

const selectPage = (state) => state.resolutioncenter.reportedIncidents.page
const selectGeneralFilter = (state) => state.resolutioncenter.reportedIncidents.generalFilter
const selectDetectedByFilter = (state) => state.resolutioncenter.reportedIncidents.detectedByFilter
const selectDateFilter = (state) => state.resolutioncenter.reportedIncidents.dateFilter
const selectSortingBy = (state) => state.resolutioncenter.reportedIncidents.sortingBy
const selectSortingDirection = (state) => state.resolutioncenter.reportedIncidents.sortingDirection

export {
  selectData,
  selectLoader,
  selectError,
  selectPage,
  selectGeneralFilter,
  selectSearch,
  selectDetectedByFilter,
  selectDateFilter,
  selectSortingBy,
  selectSortingDirection,
}
